<template>
    <div class="step_box">
        <div class="kyc_step_box">
            <div class="step_item" :class="index_active==1?'s_active':''" @click="router_push('/kyc_step/kyc_step_one')">
                <div class="step_item1">
                    <span :class="index_active==1?'active1':'' ">
                      <i v-if="one_status_icon==1" class="el-icon-check"></i>
                      <span v-else>1</span>
                    </span>
                </div>
                <div class="step_item2"><span :class="index_active==1?'active2':'' ">{{$t('main.text21')}}</span></div>
            </div>
            <div class="step_item" :class="index_active==2?'s_active':''" @click="router_push('/kyc_step/kyc_step_two')">
                <div class="step_item1">
                  <span :class="index_active==2?'active1':'' ">
                    <i v-if="two_status_icon==1" class="el-icon-check"></i>
                    <span v-else>2</span>
                  </span>
                </div>
                <div class="step_item2"><span :class="index_active==2?'active2':'' ">{{$t('main.text22')}}</span></div>
            </div>
            <div class="step_item" :class="index_active==3?'s_active':''" @click="router_push('/kyc_step/kyc_step_three')">
                <div class="step_item1">
                  <span :class="index_active==3?'active1':'' ">
                    <i v-if="three_status_icon==1" class="el-icon-check"></i>
                    <span v-else>3</span>
                  </span>
                </div>
                <div class="step_item2"><span :class="index_active==3?'active2':'' ">{{$t('main.text23')}}</span></div>
            </div>
            <div class="step_item" :class="index_active==4?'s_active':''" @click="router_push('/kyc_step/kyc_step_four')">
                <div class="step_item1">
                  <span :class="index_active==4?'active1':'' ">
                    <i v-if="four_status_icon==1" class="el-icon-check"></i>
                    <span v-else>4</span>
                  </span>
                </div>
                <div class="step_item2"><span :class="index_active==4?'active2':'' ">{{$t('main.text24')}}</span></div>
            </div>
        </div>
        <router-view></router-view>

      <!-- 不管第几步 全部填完 提示是否提交 -->
      <el-dialog
        :visible.sync="info_all_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../assets/img/warning_icon2.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text80')}}
        </div>
        <div class="log_out3">
          {{$t('main.text81')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button class="cancel_btn">Submit now</el-button> -->
            <el-button type="primary" class="confirm_btn" @click="submit_now">{{$t('main.text67')}}</el-button>
            <div class="do_it_later" @click="info_all_dlg = false">{{$t('main.text65')}}</div>
        </span>
      </el-dialog>

      <!-- 如果用户上传文件或者填写内容后没有保存，然后点击其他导航，系统会弹窗提示让用户保存内容或者留在目前的页面 -->
      <el-dialog
        :visible.sync="$store.state.login.data_no_router"
        custom-class="log_out_dlg_bgc"
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../assets/img/warning_icon.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text262')}}
        </div>
        <!-- <div class="log_out3">
          {{$t('main.text129')}}
        </div> -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="$store.state.login.data_no_router = false" class="cancel_btn_4_true">{{$t('main.text7')}}</el-button>
            <el-button type="primary" class="confirm_btn_4_true" @click="router_4_confirm">{{$t('main.text263')}}</el-button>
        </span>
      </el-dialog>

    </div>
</template>

<script>
import {getKycInfo,kyc_all_submit} from '@/api/api';
export default {
  data() {
    return {
      index_active:1,
      one_status_icon:'',//状态 0信息不完整 1信息完整,
      two_status_icon:'',//状态 0信息不完整 1信息完整,
      three_status_icon:'',//状态 0信息不完整 1信息完整,
      four_status_icon:'',//状态 0信息不完整 1信息完整,
      info_all_dlg:false,

    };
  },
  methods: {
    set_active(){
      if(this.$route.path.indexOf('kyc_step_one')!=-1){
        this.index_active = 1;
      }else if(this.$route.path.indexOf('kyc_step_two')!=-1){
        this.index_active = 2;
      }else if(this.$route.path.indexOf('kyc_step_three')!=-1){
        this.index_active = 3;
      }else if(this.$route.path.indexOf('kyc_step_four')!=-1){
        this.index_active = 4;
      }

    },
    router_push(v){
      if(this.$route.path!=v){
        this.$router.push(v);
      }

    },
    get_kyc(){
      getKycInfo().then(res=>{
        if(res.data.code==200){
          this.one_status_icon=res.data.data.corporate_fi_status;
          this.two_status_icon=res.data.data.company_status;
          this.three_status_icon=res.data.data.shareholder_status;
          this.four_status_icon=res.data.data.trading_status;
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
    info_4_all_dlg(){

      getKycInfo().then(res=>{
        if(res.data.code==200){
          this.one_status_icon=res.data.data.corporate_fi_status;
          this.two_status_icon=res.data.data.company_status;
          this.three_status_icon=res.data.data.shareholder_status;
          this.four_status_icon=res.data.data.trading_status;

            if(this.one_status_icon==1&&
              this.two_status_icon==1&&
              this.three_status_icon==1&&
              this.four_status_icon==1
            ){
                this.info_all_dlg=true;
            }else{
              this.info_all_dlg=false;
            }

            if(this.$store.state.login.data_no_router&&this.$store.state.login.to_path){
              setTimeout(() => {
                this.$store.state.login.data_no_router=false;
                this.$router.push(this.$store.state.login.to_path);
              }, 200);
            }

        }
      })

    },
    submit_now(){
      // code 509 成功
      kyc_all_submit().then(res=>{
        if(res.data.code==509){
          this.message.ismessage('success',res.data.msg);
          this.info_all_dlg=false;
          if(this.$route.path!='/user_info'){
            this.$router.push('/user_info');
          }
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
    router_4_confirm(){
      this.bus.$emit('router_4_child',this.index_active);
    }


  },
  mounted() {
    this.set_active();
    this.get_kyc();
    this.bus.$on('info_4_all',()=>{
      this.info_4_all_dlg();
    });
  },
  beforeDestroy(){
    this.bus.$off('info_4_all');
  },
  watch:{
    $route(){
      this.set_active();
    },
  }
};
</script>

<style scoped>
.step_box{
  display: flex;
  height: calc(100vh - 160px);
  /* justify-content: space-between; */
}
@media screen and (max-width: 850px) {
  .step_box{
    display: block;
  }
}

.kyc_step_box{
    display: inline-block;
    background: #04182A;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 20px;
    color: #fff;
    margin-right: 40px;
    height: fit-content;
    width: 280px;
}
.step_item{
    display: flex;
    align-items: center;
    margin: auto;
    cursor: pointer;
    box-sizing: border-box;
    padding: 10px 20px;
}
.s_active{
  background: #041E35;
  border-radius: 8px;
}
.step_item1>span{
    display: inline-block;
    width: 26px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    border-radius: 50%;
    font-size: 12px;
    border: 1px solid #fff;
    margin-right: 9px;
    opacity: 0.6;
}
.step_item2{
    max-width: 164px;
    word-wrap: break-word;
    word-break: break-word;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    letter-spacing: 0.1px;
}
.active1{
    color: #DEB981;
    border-color: #DEB981 !important;
}
.active2{
    color: #DEB981;
}

/* 退出弹框 */
.log_out1 img{
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  text-align: center;
}
.log_out3{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
}
.cancel_btn{
  color: #F1C788;
  border-color: #F1C788;
  background: transparent;
}
.confirm_btn{
  width: 163px;
  height: 38px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #F1C788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182A;
  /* margin-left: 20px; */
  margin-bottom: 15px;
}
.do_it_later{
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #DEB981;
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
}

/* --over-- */

.cancel_btn_4_true{
  color: #F1C788;
  border-color: #F1C788;
  background: transparent;
}
.confirm_btn_4_true{
  /* width: 130px; */
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #F1C788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #04182A;
  margin-left: 20px;
  margin-bottom: 15px;
}
</style>
<style>
.el-upload-list__item:hover {
  background: none;
  border: 1px solid #F5F7FA;
}
.el-upload-list__item.is-success .el-upload-list__item-name:focus, .el-upload-list__item.is-success .el-upload-list__item-name:hover{
  color: #fff;
}
.el-upload-list__item:hover .el-icon-close {
  color: #fff;
}
.el-icon-close-tip{
  display: none;
}
.focusing{
  display: none;
}

</style>

<style>
  /* 手机端 */
/* 单个日历的宽度 */
@media screen and (max-width: 850px){
  .el-picker-panel__content {
    width: 87% !important;
  }
}
</style>